var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSparksColored = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  className: "sparks-colored_svg__svg-safari-fix",
  viewBox: "0 0 20 20",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFDB99",
  d: "M10 15h2v2h-2zM6 5h3v3H6z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FFDB99",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M11.925 6.813c-2.875.562-3.75 1.437-4.313 4.312C7.05 8.25 6.176 7.375 3.3 6.813 6.175 6.25 7.05 5.375 7.613 2.5c.562 2.875 1.437 3.75 4.312 4.313M14 16c-2 .375-2.562 1-3 3-.375-2-1-2.562-3-3 2-.375 2.563-1 3-3 .375 2 1 2.625 3 3M18.575 9.938c-1.625.312-2.125.812-2.437 2.437-.313-1.625-.813-2.125-2.438-2.437 1.625-.313 2.125-.813 2.438-2.438.312 1.625.812 2.125 2.437 2.438"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FFB424",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M11.187 6.188c-2.875.563-3.75 1.438-4.312 4.313-.563-2.875-1.438-3.75-4.313-4.312 2.875-.563 3.75-1.438 4.313-4.313.562 2.875 1.437 3.75 4.312 4.313M13.626 15.626c-2 .375-2.562 1-3 3-.375-2-1-2.563-3-3 2-.375 2.563-1 3-3 .375 2 1 2.625 3 3M18.125 9.375c-1.625.313-2.125.813-2.437 2.438-.313-1.625-.813-2.125-2.438-2.438 1.625-.312 2.125-.812 2.438-2.437.312 1.625.812 2.125 2.437 2.437"
})));
export default SvgSparksColored;